<div class="component-content">
  <mat-form-field class="lc-form-field" appearance="outline">
    <label>Period</label>
    <mat-date-range-input [formGroup]="tasksDateRange" [rangePicker]="picker">
      <input readonly matStartDate formControlName="from" placeholder="From">
      <input readonly matEndDate formControlName="to" placeholder="To" (dateChange)="reportDateChange()">
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</div>